<div class="container d-flex justify-content-center">
    <div class="row">
        <div class="col-sm-6 center">
            <h1>Inicio</h1>

        </div>
    </div>
</div>


<div class="row mt-3">
    <div class="col center ml-2">       
        <div class="container d-flex justify-content-center">
            <div class="card" style="width: 45rem;">
                <div class="card-body">
                  <h5 class="card-title">Primer Paso</h5>
                  
                  <p class="card-text">
                    Se debe rellenar los datos en la pestaña de <b>Registrar</b> en el menú de la izquierda una vez 
                    registrado debe de loguearse en la pestaña <b>Login</b> con los datos correspondientes.
                  </p>
              </div>
        </div>
    </div>
</div>

</div>


<div class="row mt-3">
    <div class="col center ml-2">       
        <div class="container d-flex justify-content-center">
            <div class="card" style="width: 45rem;">
                <div class="card-body">
                  <h5 class="card-title">¿Como Funciona?</h5>
                  
                  <p class="card-text">Es una herramienta para organizar y ayudar a estudiar diferentes temas, organizando 
                      con materias que contienen unidades y cada unidad tiene contenido los temas con una descripcion.
                  </p>
              </div>
        </div>
    </div>
</div>
</div>


<div class="row mt-3">
    <div class="col center ml-2">       
        <div class="container d-flex justify-content-center">
            <div class="card" style="width: 45rem;">
                <div class="card-body">
                  <h5 class="card-title">Formas de uso</h5>
                  
                  <p class="card-text"></p>
                  <ul>
                      <li class="mt-2">
                        Se puede usar como predeterminado ingresando la Materia, Unidades y Temas.
                      </li>
                      <li class="mt-2" >
                          Se puede usar como una secuencia de pasos a seguir, describiendo los pasos en la pestaña "Temas".
                      </li>
                      <li class="mt-2">
                          Otra forma de uso es el tener un item y que cada item tenga una descripcion.
                      </li>
                  </ul>
              </div>
        </div>
        
       
    </div>
</div>
</div>